module.exports = __webpack_public_path__ + "media/images/emblems/Conters_i_P_wappen-8097316fb28b960c44050c0fcf67385d.svg";